export const cssPrefix = 'znl-common-footer';

export const __DEV__ = process.env.NODE_ENV !== 'production';
